import { useIsHubCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsHubCategory";

export const useIsHubCategoryLoadingStrategy = (): boolean => {
  return useIsHubCategory().isHubCategory;
};
